import { ActionIntegration } from '../../../domain/ActionIntegration'
import { ApplicationState } from '../../ApplicationState'
import { getActionIntegrationState } from '../V2State'

export interface ActionIntegrationState {
    byId: { [key: number]: ActionIntegration }
    byTracepointServiceEnvironment: { [key: string]: number[] }
    loaded: boolean
}

export const getActiveActionIntegrations = (state: ApplicationState): ActionIntegration[] => {
    return Object.keys(getActionIntegrationState(state).byId)
        .map(id => getActionIntegrationState(state).byId[id])
        .filter(actionIntegration => !actionIntegration.deleted)
}

export const getActiveTracepointIntegrations = (state: ApplicationState, environment: string, service: string): ActionIntegration[] => {
    const key = `${environment}::${service}`

    if (!(key in getActionIntegrationState(state).byTracepointServiceEnvironment)) {
        return []
    }

    return getActionIntegrationState(state)
        .byTracepointServiceEnvironment[key].map(id => getActionIntegrationState(state).byId[id])
        .filter(actionIntegration => !actionIntegration.deleted)
}

export const areTracepointActionIntegrationsLoaded = (state: ApplicationState, environment: string, service: string): boolean => {
    const key = `${environment}::${service}`

    return key in getActionIntegrationState(state).byTracepointServiceEnvironment
}

export const areActionIntegrationsLoaded = (state: ApplicationState): boolean => getActionIntegrationState(state).loaded || false
